var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"width-100 flex-centerize flex-column"},_vm._l((_vm.fields),function(field){return _c('InterfaceBlocksSelectorItem',{key:field.id,staticClass:"pl-2 mb-3",attrs:{"field":field,"configurationId":_vm.configurationId},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }